import React, {useRef, useState} from 'react';
import DescriptionComponent from "./DescriptionComponent";
import ModalComponent from "./ModalComponent";

import { Label, Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { ChevronUpDownIcon } from '@heroicons/react/16/solid'
import { CheckIcon } from '@heroicons/react/20/solid'

const departamento =[
    { nombre: '' },
    { nombre: 'Administración' },
    { nombre: 'Almacén' },
    { nombre: 'Calidad' },
    { nombre: 'Comercial' },
    { nombre: 'Compensaciones' },
    { nombre: 'Compras' },
    { nombre: 'Control Vehicular' },
    { nombre: 'Desarrollo Organizacional' },
    { nombre: 'Dirección General' },
    { nombre: 'Finanzas' },
    { nombre: 'Legal' },
    { nombre: 'Marketing' },
    { nombre: 'Operaciones PI' },
    { nombre: 'Operaciones PE' },
    { nombre: 'Planeación' },
    { nombre: 'Recursos Humanos' },
    { nombre: 'Reingenieria de Procesos' },
    { nombre: 'Servicios Generales' },
    { nombre: 'Sistemas' },
    { nombre: 'Taller de Herramientas' },
    { nombre: 'TI' },
    { nombre: 'Otro (Capturar en "Descripción breve de tu Iniciativa")' }
]

const cdo =[
    { nombre : ''},
    { nombre : 'CDO Ganaderos'},
    { nombre : 'CDO Ladoga'},
    { nombre : 'CDO Pantitlan'},
    { nombre : 'CDO Coacalco'},
    { nombre : 'CDO Huehuetoca'},
    { nombre : 'CDO Texcoco'},
    { nombre : 'CDO Puebla'},
    { nombre : 'CDO Toluca'},
    { nombre : 'CDO Queretaro'},
    { nombre : 'CDO Celaya'},
    { nombre : 'CDO Agusacalientes'},
    { nombre : 'CDO Guadalajara'},
    { nombre : 'CDO Vallarta'},
    { nombre : 'CDO Monterrey'},
    { nombre : 'Corporativo Santa Fe'},
    { nombre : 'Otro (Capturar en "Descripción breve de tu Iniciativa")'}
]

const participar = [
    {nombre : ''},
    {nombre : 'Sí, me gustaría participar'},
    {nombre : 'No, prefiero no participar'},
    {nombre : 'Tal vez, dependiendo de la disponibilidad'}
    ]

function IdeaForm() {

    const [departamentoSelected, setDepartamentoSelected] = useState(departamento[0]);
    const [cdoSelected, setCdoSelected] = useState(cdo[0]);
    const [participarSelected, setParticiparSelected] = useState(participar[0]);
    const [isLoading, setIsLoading] = useState(false);

    const formStyle: React.CSSProperties = {
        maxWidth: '600px',
        margin: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '12px',
        fontFamily: 'Arial'
    };

    const [formData, setFormData] = useState({
        nombre_completo: '',
        telefono_correo: '',
        area_departamento: '',
        cdo: '',
        nombre_iniciativa: '',
        descripcion: '',
        aporte: '',
        desea_participar: ''
    });

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };


    const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));

    const [modalAbierto, setModalAbierto] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsLoading(true);
        if (!formData.area_departamento || !formData.cdo || !formData.desea_participar){
            alert("Por favor llena todos los campos.");
            setIsLoading(false);
            return;
        }

        try {
            const response = await fetch('https://apis.grupobrame.com/api/ideas',
                {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*'},
                body: JSON.stringify(formData)
            });
            console.log(JSON.stringify(formData));

            const result = await response.json();

            if (result.success) {
                setIsLoading(false);
                //alert('Iniciativa enviada con éxito');

                setFormData({
                    nombre_completo: '',
                    telefono_correo: '',
                    area_departamento: '',
                    cdo: '',
                    nombre_iniciativa: '',
                    descripcion: '',
                    aporte: '',
                    desea_participar: ''
                });
                setModalAbierto(true);

                await sleep(14200);
                window.location.href = "https://www.grupobrame.com/";

            } else {
                alert('Error al enviar');
                setIsLoading(false);
            }
        } catch (err) {
            console.error(err);
            alert('Error de red');
            setIsLoading(false);
        }
    };

    return (
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 pt-12" id="wrapNube">
            <DescriptionComponent></DescriptionComponent>
            <video autoPlay loop muted playsInline src={require('../img/NUBETECA  PAGE.mp4')} className="rounded-3xl mb-4" id="videoNube"></video>


            <form onSubmit={handleSubmit} style={formStyle} aria-busy={isLoading}>

                <div className="space-y-12 mt-4">
                    <div className="border-b border-gray-900/10 pb-12">
                        <h2 className="text-base/7 font-semibold text-gray-900">Llena esta sección con tus datos personales para que podamos contactarte.</h2>
                        <div className="mt-10 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                            <div className="sm:col-span-6">
                                <label htmlFor="nombre_completo" className="block text-sm/6 font-medium text-gray-900">
                                    Nombre Completo
                                </label>
                                <div className="mt-2">
                                    <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-orange-500">
                                        <input
                                            id="nombre_completo"
                                            name="nombre_completo"
                                            type="text"
                                            placeholder="Juan José Jiménez López"
                                            className="block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
                                            value={formData.nombre_completo}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="sm:col-span-6">
                                <label htmlFor="telefono_correo" className="block text-sm/6 font-medium text-gray-900">
                                    Teléfono ó Correo Electronico
                                </label>
                                <div className="mt-2">
                                    <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-orange-500">
                                        <input
                                            id="telefono_correo"
                                            name="telefono_correo"
                                            type="text"
                                            placeholder="55 25894135 o juanjose@correo.com"
                                            className="block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
                                            value={formData.telefono_correo}
                                            onChange={handleChange}
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="sm:col-span-3">
                                <Listbox
                                    value={departamentoSelected}
                                    onChange={(selected) => {
                                        setDepartamentoSelected(selected);
                                        setFormData((prev) => ({
                                            ...prev,
                                            area_departamento: selected.nombre
                                        }));
                                    }}
                                >
                                    <Label
                                        htmlFor="area_departamento"
                                        className="block text-sm/6 font-medium text-gray-900"
                                    >
                                        Área / Departamento
                                    </Label>

                                    <div className="relative mt-2">
                                        <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6">
        <span className="col-start-1 row-start-1 truncate pr-6">
          {departamentoSelected.nombre || 'Selecciona un área'}
        </span>
                                            <ChevronUpDownIcon
                                                aria-hidden="true"
                                                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                            />
                                        </Listbox.Button>

                                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                            {departamento.map((depa) => (
                                                <Listbox.Option

                                                    value={depa}
                                                    className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                >
            <span className="block truncate font-normal group-data-selected:font-semibold">
              {depa.nombre}
            </span>
                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
              <CheckIcon aria-hidden="true" className="size-5" />
            </span>
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>


                            <div className="sm:col-span-3">
                                <Listbox
                                    value={cdoSelected}
                                    onChange={(selected) => {
                                        setCdoSelected(selected);
                                        setFormData((prev) => ({
                                            ...prev,
                                            cdo: selected.nombre
                                        }));
                                    }}
                                >
                                    <Label
                                        htmlFor="area_departamento"
                                        className="block text-sm/6 font-medium text-gray-900"
                                    >
                                        CDO / Distrito al que perteneces
                                    </Label>

                                    <div className="relative mt-2">
                                        <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6">
        <span className="col-start-1 row-start-1 truncate pr-6">
          {cdoSelected.nombre || 'Selecciona un CDO/Distrito'}
        </span>
                                            <ChevronUpDownIcon
                                                aria-hidden="true"
                                                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                            />
                                        </Listbox.Button>

                                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                            {cdo.map((cd) => (
                                                <Listbox.Option

                                                    value={cd}
                                                    className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                >
            <span className="block truncate font-normal group-data-selected:font-semibold">
              {cd.nombre}
            </span>
                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
              <CheckIcon aria-hidden="true" className="size-5" />
            </span>
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>

                            <div className="sm:col-span-6">
                                <label htmlFor="nombre_iniciativa" className="block text-sm/6 font-medium text-gray-900">
                                    Nombre de tu Iniciativa
                                </label>
                                <div className="mt-2">
                                    <div className="flex items-center rounded-md bg-white pl-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-orange-500">
                                        <input
                                            id="nombre_iniciativa"
                                            name="nombre_iniciativa"
                                            value={formData.nombre_iniciativa}
                                            onChange={handleChange}
                                            required
                                            type="text"
                                            placeholder=""
                                            className="block min-w-0 grow py-1.5 pr-3 pl-1 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-span-full">
                                <label htmlFor="descripcion" className="block text-sm/6 font-medium text-gray-900">
                                    Descripción breve de tu Iniciativa
                                </label>
                                <div className="mt-2">
                                    <textarea
                                        id="descripcion"
                                        name="descripcion"
                                        maxLength={500}
                                        value={formData.descripcion}
                                        onChange={handleChange}
                                        rows={4}
                                        required
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        defaultValue={''}
                                    />
                                </div>
                            </div>

                            <div className="col-span-full">
                                <label htmlFor="descripcion" className="block text-sm/6 font-medium text-gray-900">
                                    ¿Qué aporta esta idea a la empresa?
                                </label>
                                <div className="mt-2">
                                    <textarea
                                        id="descripcion"
                                        name="aporte"
                                        value={formData.aporte}
                                        onChange={handleChange}
                                        rows={3}
                                        required
                                        maxLength={500}
                                        className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        defaultValue={''}
                                    />
                                </div>
                                <p className="mt-3 text-xs text-gray-600">Puedes enfocarte en eficiencia, ahorro, experiencia de cliente, clima laboral, sustentabilidad, etc.</p>
                            </div>

                            <div className="sm:col-span-6">
                                <Listbox
                                    value={participarSelected}
                                    onChange={(selected) => {
                                        setParticiparSelected(selected);
                                        setFormData((prev) => ({
                                            ...prev,
                                            desea_participar: selected.nombre
                                        }));
                                    }}
                                >
                                    <Label
                                        htmlFor="desea_participar"
                                        className="block text-sm/6 font-medium text-gray-900"
                                    >
                                        ¿Deseas participar en el desarrollo o implementación de tu iniciativa?
                                    </Label>

                                    <div className="relative mt-2">
                                        <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6">
        <span className="col-start-1 row-start-1 truncate pr-6">
          {participarSelected.nombre || 'Selecciona una opción'}
        </span>
                                            <ChevronUpDownIcon
                                                aria-hidden="true"
                                                className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                            />
                                        </Listbox.Button>

                                        <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                            {participar.map((participacion) => (
                                                <Listbox.Option

                                                    value={participacion}
                                                    className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                >
            <span className="block truncate font-normal group-data-selected:font-semibold">
              {participacion.nombre}
            </span>
                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
              <CheckIcon aria-hidden="true" className="size-5" />
            </span>
                                                </Listbox.Option>
                                            ))}
                                        </Listbox.Options>
                                    </div>
                                </Listbox>
                            </div>

                            <div className="mt-6 flex items-center justify-center gap-x-6">
                                <button
                                  type="submit"
                                  disabled={isLoading}
                                  className={`rounded-md bg-[#D75313] px-3 py-2 text-sm font-semibold text-white shadow-xs focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-500 ${isLoading ? 'opacity-60 cursor-not-allowed' : 'hover:bg-orange-700'}`}
                                >
                                  {isLoading ? (
                                    <span className="inline-flex items-center gap-2">
                                      <svg
                                        className="animate-spin h-4 w-4"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        aria-hidden="true"
                                      >
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                      </svg>
                                      Enviando...
                                    </span>
                                  ) : (
                                    'Enviar'
                                  )}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
            <ModalComponent
                isOpen={modalAbierto}
                onClose={() => setModalAbierto(false)}
                videoSrc={require('../img/NUBETECA  GRACIAS.mp4')}
            />
        </div>


    );
}

export default IdeaForm;

